export default "__VITE_ASSET__CgSy0Qe6__"